import { IXandrNativeAdObject } from "@almamedia/amr-adtech-stack/lib/services/ads";
import { attachClickTracker } from "@almamedia/amr-adtech-stack/lib/services/native/native-helpers";

const nativeRectangleBlackSmall = {
  name: "native_rectangle_black_small",
  buildContent: (adObj: IXandrNativeAdObject, wrapperId: string): string => {
    const { native } = adObj;
    let nativeContent = "";

    const title = native.title ?? "";
    const sponsoredBy = native.sponsoredBy ?? "";
    const imageUrl = native.image?.url;

    // Opening tag
    // nativeContent += `<div id="${wrapperId}">`;

    nativeContent +=
      `<div id="${wrapperId}">` +
      `	<div id="${wrapperId}_content_wrapper" class="${wrapperId}_sizing">` +
      `		<div id="${wrapperId}_img_wrapper">` +
      `  		<img src="${imageUrl}" id="${wrapperId}_img">` +
      `  	</div>` +
      `		<div id="${wrapperId}_right_container">` +
      `  		<div id="${wrapperId}_sponsored_by_wrapper">` +
      `    		<span id="${wrapperId}_sponsored">Mainos:</span>` +
      `    		<span id="${wrapperId}_sponsored_by">${sponsoredBy}</span>` +
      `			</div>` +
      `  		<div id="${wrapperId}_text">` +
      `  			<div id="${wrapperId}_title">${title}</div>` +
      `			</div>` +
      ` 	</div>` +
      `	</div>` +
      `</div>`;

    // Closing tag
    // nativeContent += `</div>`;
    return nativeContent;
  },
  buildStyles: (wrapperId: string): string => {
    return (
      `${
        '@font-face{font-family:GalanoGrotesqueAlt-Regular;src:url(https://cdn.almamedia.fi/fonts/GalanoGrotesqueAlt/2018-04-06/GalanoGrotesqueAlt-Regular.woff2) format("woff2"),url(https://cdn.almamedia.fi/fonts/GalanoGrotesqueAlt/2018-04-06/GalanoGrotesqueAlt-Regular.woff) format("woff")}@font-face{font-family:GalanoGrotesqueAlt-SemiBold;src:url(https://cdn.almamedia.fi/fonts/GalanoGrotesqueAlt/2018-04-06/GalanoGrotesqueAlt-SemiBold.woff2) format("woff2"),url(https://cdn.almamedia.fi/fonts/GalanoGrotesqueAlt/2018-04-06/GalanoGrotesqueAlt-SemiBold.woff) format("woff")}' +
        "#"
      }${wrapperId}{font-family: GalanoGrotesqueAlt-SemiBold,Helvetica,sans-serif;background-color:#fff;border-top:1px solid #ddd;border-bottom:1px solid #ddd;cursor:pointer;clear:both}` +
      `#${wrapperId}_content_wrapper{width:100%;}` +
      `.${wrapperId}_sizing{box-sizing: border-box;display:flex;}` +
      `#${wrapperId}_img_wrapper{padding: 14px 0 14px 14px;max-width:120px;flex:8;}` +
      `#${wrapperId}_img{width:100%}` +
      `#${wrapperId}_right_container{flex: 14;padding:0 0 14px 14px;min-width:0;}` +
      `#${wrapperId}_sponsored_by_wrapper{font-size: 11px;background-color:#222;color:#fff;min-height:20px;padding:3px 0 3px 0;}` +
      `#${wrapperId}_sponsored{letter-spacing: .5px;text-transform:uppercase;padding:4px 5px 2px 5px;}` +
      `#${wrapperId}_sponsored_by{padding: 4px 5px 2px 0;}` +
      `#${wrapperId}_text{word-wrap: break-word;padding:7px 14px 0 0;}` +
      `#${wrapperId}_title{text-decoration: none;font-size:15.5px;line-height:14px;}`
    );
  },
  attachClick: attachClickTracker,
};

export default nativeRectangleBlackSmall;
